import TabPage from "./../../factories/tab-page";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
class ConfigurationItemInfrastructureTab {
    Bao = Bao;
    DomainName = ko.observable();
    OperatingTypeId = ko.observable();
    OperatingTypeName = ko.observable();
    InstallationTypeId = ko.observable();
    InstallationTypeName = ko.observable();
    Loading = ko.observable<boolean>(false);
    constructor(public TabPage: TabPage, public Parent) {
        this.TabPage.DirtyFlag.subscribe((isDirty) => {
            if (isDirty) {
                this.Parent.TabPage.DirtyFlag(true);
            }
        });
    }
    CompleteCheck() {
        var def = $.Deferred();
        def.resolve(true);
        return def.promise();
    }
    Refresh() {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemInfrastructureTab/Get", JSON.stringify({
            id: this.Parent.ConfigurationItemId(),
        }), (result) => {
            if (result != null) {
                ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
            }
            this.Loading(false);
            this.TabPage.IsLoading(false);
        });
    }
    Save(saveTime) {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemInfrastructureTab/Save", JSON.stringify({
            saveTime: saveTime,
            model: ko.map.toJS(this)
        }), (result) => {
            this.Loading(false);
            this.TabPage.DirtyFlag(false);
            this.TabPage.IsLoading(false);
        });
    }
    init() {
    }
    loaded() {
        return this.Refresh();
    }
    ;
}
export default ConfigurationItemInfrastructureTab;